module.exports = __webpack_public_path__ + "static/media/Corn1V1-V2.85358433.png";